<app-globalpay></app-globalpay>
<app-rms></app-rms>
<app-apcopay #apcopayComponent></app-apcopay>
<app-trustpayment #trustpaymentComponent></app-trustpayment>
<app-jcc #jccComponent></app-jcc>
